import * as React from 'react';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Anchor, AnchorProps, Button } from '@mantine/core';
import { createLink, LinkComponent } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import classes from './VersionSelectPreviousVersion.module.css';

type AnchorComponentProps = Omit<AnchorProps, 'href'> & {
  disabled?: boolean;
};

const MantineAnchorComponent = React.forwardRef<
  HTMLAnchorElement,
  AnchorComponentProps
>((props, ref) => {
  const { t } = useTranslation();
  const { disabled, ...rest } = props;

  return (
    <Anchor
      ref={ref}
      {...rest}
      className={disabled ? classes.disabled : classes.default}
    >
      <Button
        size="xs"
        variant="light"
        c={disabled ? 'lightgray' : 'gray'}
        leftSection={<FontAwesomeIcon icon={faArrowLeft} />}
      >
        {t('VERSION_SELECT.PREVIOUS_VERSION')}
      </Button>
    </Anchor>
  );
});

MantineAnchorComponent.displayName = 'MantineAnchorComponent';

const CreatedLinkComponent = createLink(MantineAnchorComponent);

export const VersionSelectPreviousVersion: LinkComponent<
  typeof MantineAnchorComponent
> = (props) => {
  return <CreatedLinkComponent {...props} />;
};
